import getAddedProviders from '../utils/getAddedProviders';
import { FilePickerPreloadState } from '../store/schema/FilePickerPreloadState';
import { getFilePickerStore } from '../store/filePickerStore';
import { getProviderLoadState } from 'owa-fileprovider-store/lib/selectors/getProviderLoadState';
import { initializeFilePickerViewState } from '../utils/initializeFilePickerViewState';
import { setPreloadState } from '../actions/internalActions';
import {
    FileProviderViewState,
    lazyLoadProviders,
    ProviderLoadStateOption,
} from 'owa-fileprovider-store';

const pendingCallbacks = [];

export default async function preloadFilePicker(callback?: () => void) {
    const preloadState = getFilePickerStore().viewState.preloadState;
    const providerLoadState = getProviderLoadState();

    const onLoaded = (providers: FileProviderViewState[]) => {
        initializeViewState(providers);
        callback?.();
        pendingCallbacks.forEach(callback => callback());
    };

    // Adding the callback to pending callbacks list since loading the file providers has already been started
    if (
        preloadState === FilePickerPreloadState.Loading ||
        providerLoadState === ProviderLoadStateOption.Loading
    ) {
        if (callback) {
            pendingCallbacks.push(callback);
        }
        return;
    }

    if (preloadState !== FilePickerPreloadState.Loaded) {
        setPreloadState(FilePickerPreloadState.Loading);
        if (providerLoadState === ProviderLoadStateOption.NotLoaded) {
            const loadProviders = await lazyLoadProviders.import();
            loadProviders(onLoaded, onError);
        } else {
            onLoaded(getAddedProviders());
        }
    }
}

function initializeViewState(providers: FileProviderViewState[]) {
    initializeFilePickerViewState(providers);
    setPreloadState(FilePickerPreloadState.Loaded);
}

function onError(error: Error) {
    setPreloadState(FilePickerPreloadState.NotLoaded);
}
